import { createSvgComponent } from "../../icon/createSvgComponent";
import Slate from "@core/__generated__/icon/figma/slate.svg";
export default createSvgComponent(Slate);